import React, {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {applicationSelector, closeAlert} from '../../redux/application'
import {Snackbar} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

//TODO: несколько снеков

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function DisplayAlert(props) {

  const dispatch = useDispatch();
  const {isShowAlert, alertText, severity} = useSelector(applicationSelector);

  let errorText =  '';
  if (alertText && alertText.errorDetails) errorText = alertText.errorDetails;
  else if (alertText && alertText.error) errorText = alertText.error;
  else errorText = alertText || 'Виникла помилка';

  const handleClose = () => dispatch(closeAlert());

  return (
    <Snackbar open={isShowAlert}
              autoHideDuration={10000}
              onClose={handleClose}
              ClickAwayListenerProps={{ mouseEvent: "onMouseUp" }}
    >
      <Alert severity={severity} onClose={handleClose}>{errorText}</Alert>
    </Snackbar>
  );
}

